<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e837330" style="color: #82a339"><b>ROASTED RED PEPPER DIP</b></p>
<p class="ext" id="d7e837830"><b><i>Fresh roasted red peppers are what make this dip special, so don’t substitute the ones that come in a jar. Roasting peppers is easy to do. If you’ve never done it, this is the perfect opportunity. Once you’ve tasted them, you’ll wonder why you waited so long.</i></b></p>
<p class="h4" id="d7e839730" style="color: #496210"><b>Prep: 45 minutes</b></p>
<p class="ul" id="d7e840230">4 red peppers, roasted</p>
<p class="ul" id="d7e840530">½ teaspoon ground cumin</p>
<p class="ul" id="d7e841430">½ cup walnuts, toasted</p>
<p class="ul" id="d7e842430">2 slices firm white bread, torn into pieces</p>
<p class="ul" id="d7e842730">2 tablespoons raspberry or balsamic vinegar</p>
<p class="ul" id="d7e843030">1 tablespoon olive oil</p>
<p class="ul" id="d7e843330">½ teaspoon salt</p>
<p class="ul" id="d7e844330">⅛ teaspoon ground red pepper (cayenne) <br/> toasted pita bread wedges</p>
<p class="pub" id="d7e845730" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Cut roasted peppers into large pieces. In small skillet, toast cumin over low heat, stirring constantly, until very fragrant, 1 to 2 minutes.</p>
<p class="pub" id="d7e847030"><span style="color: #c15b49"><b>2.</b></span> In food processor with knife blade attached, process walnuts until ground. Add roasted peppers, cumin, bread, vinegar, oil, salt, and ground red pepper; puree until smooth. Transfer to bowl. If not serving right away, cover and refrigerate up to 4 hours. Serve with toasted pita bread wedges. Makes about 2 cups.</p>
<p class="ntx" id="d7e849730">Each tablespoon: About 23 calories, 0g protein, 2g carbohydrate, 2g total fat (0g saturated), 0mg cholesterol, 46mg sodium.</p>
<p class="ser"><img alt="9781618371621_0030_001" src="Images/9781618371621_0030_001.jpg" style="max-width:100%;"/></p>
<p class="cap" id="d7e850930"><i>Roasted Red Pepper Dip</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c10_r1.vue?2a2ebbb6